import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import StudentImage from '../../../models/StudentImage'

export default function usePastImages({
  cart,
  currentStudent,
  isDownloadImages,
  isUsingAccessCode,
}) {
  const history = useHistory()
  const [studentImages, setStudentImages] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasNoPastImages, setHasNoPastImages] = useState(false)

  useEffect(() => {
    const downloadImageParams = { studentId: currentStudent.id }
    const standardParams = { folder: { not_already_selected_for_cart: cart.id } }
    const query = isDownloadImages ? downloadImageParams : standardParams

    if (!(isUsingAccessCode || isDownloadImages)) {
      history.push('/review')
      return
    }

    StudentImage
      .includes('poses')
      .selectExtra(['packageId'])
      .where({ studentId: currentStudent.id })
      .where(query)
      .all()
      .then((res) => {
        if (res.data.length === 0) {
          if (!isDownloadImages) {
            history.push('/review')
          } else {
            setLoading(false)
            setHasNoPastImages(true)
          }
          return
        }

        const imagesWithUrlAndPackage = res
          .data
          .filter((image) => image.watermarkUrl && !image.watermarkUrl.includes('missing.png') && !!image.packageId)

        setStudentImages(imagesWithUrlAndPackage)
      })
      .finally(() => setLoading(false))
  }, [])

  return { loading, studentImages, hasNoPastImages }
}
